export const ModalStyles = () => (
  <style jsx global>{`
    html,
    body {
      overflow: hidden;
    }
  `}</style>
);
